module.exports = __webpack_public_path__ + "media/4x3/vu-859836e7.svg";